var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/lodash/_metaMap.js